import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class ExcelToPdfHelperService {
  constructor() { }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR') + ' ' + date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  }

  formatDateOnly(dateString: string): string {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('tr-TR');
  }

  createCheckboxList(options: any[], selectedId: any): string {
    if (!options) return '';
    return options.map(opt => {
      const isSelected = opt?.valueObject?.id?.value === selectedId;
      return `
        <label class="checkbox-item">
          <input type="checkbox" ${isSelected ? 'checked' : ''} onclick="return false;">
          <span>${opt?.valueObject?.name?.value ?? ''}</span>
        </label>
      `;
    }).join('');
  }

  createCheckboxListLabel(caseData: any, label: string, options?: any[]): { html: string, totalScore: number } {
    if (!caseData?.formAnswers) {
      return { html: '', totalScore: 0 };
    }

    const answer = caseData.formAnswers.find(
      (fa: any) => fa.answerLabel === label
    )?.answerValue;

    let totalScore = 0;
    let html = '';

    if (Array.isArray(options) && options.length > 0) {
      html = options.map(opt => {
        const value = opt?.valueObject?.name?.value ?? '';
        const score = Number(opt?.valueObject?.score?.value ?? 0);
        const isSelected = value === answer;
        if (isSelected && score) totalScore += score;
        const labelText = score > 0 ? `(${score}) ${value}` : value;
        return `
          <label class="checkbox-item">
            <input type="checkbox" ${isSelected ? 'checked' : ''} onclick="return false;">
            <span>${labelText}</span>
          </label>
        `;
      }).join('');
    } else if(answer){
        html = `<span>${answer}</span>`;
    }

    return { html, totalScore };
  }
}